import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '5472583',
  title: 'Responda essa pesquisa rápida sobre você',
  video: { platform: 'youtube', videoId: '1DkSm-BcmWc' },
  article: [''],
};
export default lesson;

